// extracted by mini-css-extract-plugin
export default {"headerContainer":"NotQualified_headerContainer__AYgOD","infoIcon":"NotQualified_infoIcon__BG+fr","title":"NotQualified_title__F0uI9"};